import React from 'react';
import { X } from 'lucide-react';
import { ASSET_CATEGORIES, ASSET_STATUSES } from '../../data/mockData';

const AssetFilters = ({ filters, setFilters }) => {
  const handleFilterChange = (type, value) => {
    setFilters(prev => ({
      ...prev,
      [type]: prev[type].includes(value)
        ? prev[type].filter(v => v !== value)
        : [...prev[type], value]
    }));
  };

  return (
    <div className="p-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {/* Category Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Category
          </label>
          <select 
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm"
            onChange={(e) => handleFilterChange('category', e.target.value)}
          >
            <option value="">All Categories</option>
            {ASSET_CATEGORIES.map(category => (
              <option key={category.id} value={category.id}>
                {category.label}
              </option>
            ))}
          </select>
        </div>

        {/* Status Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Status
          </label>
          <select 
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm"
            onChange={(e) => handleFilterChange('status', e.target.value)}
          >
            <option value="">All Statuses</option>
            {Object.entries(ASSET_STATUSES).map(([key, value]) => (
              <option key={key} value={key}>
                {value.label}
              </option>
            ))}
          </select>
        </div>

        {/* Date Range Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Purchase Date
          </label>
          <input
            type="date"
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm"
            onChange={(e) => setFilters(prev => ({
              ...prev,
              dateRange: e.target.value
            }))}
          />
        </div>

        {/* Value Range Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Value Range
          </label>
          <div className="flex gap-2">
            <input
              type="number"
              placeholder="Min"
              className="w-1/2 border border-gray-200 rounded-lg px-3 py-2 text-sm"
              onChange={(e) => setFilters(prev => ({
                ...prev,
                valueRange: { ...prev.valueRange, min: e.target.value }
              }))}
            />
            <input
              type="number"
              placeholder="Max"
              className="w-1/2 border border-gray-200 rounded-lg px-3 py-2 text-sm"
              onChange={(e) => setFilters(prev => ({
                ...prev,
                valueRange: { ...prev.valueRange, max: e.target.value }
              }))}
            />
          </div>
        </div>
      </div>

      {/* Active Filters */}
      <div className="mt-4 flex flex-wrap gap-2">
        {Object.entries(filters).map(([type, values]) => {
          if (!values || values.length === 0) return null;
          return (
            Array.isArray(values) ? values : [values]
          ).map(value => (
            <span 
              key={`${type}-${value}`}
              className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-[#43302b] text-white"
            >
              {value}
              <button
                onClick={() => handleFilterChange(type, value)}
                className="ml-1 hover:text-gray-200"
              >
                <X className="w-3 h-3" />
              </button>
            </span>
          ));
        })}
      </div>
    </div>
  );
};

export default AssetFilters; 